/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Drastic Technologies - Select Folder" |
*
* @param {Drastic_Tech_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_folder_title = /** @type {((inputs?: Drastic_Tech_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drastic Technologies - Selectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drastic Technologies – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Drastic Technologies - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Drastic Technologies - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Drastic Technologies - Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Drastic Technologies - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Drastic Technologies - フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रैस्टिक टेक्नोलॉजीज - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tecnologias drásticas - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Drastic Technologies - Select Folder")
});